import { Modal } from '@components/Modal'
import ContactForm from '@components/_contact/ContactForm'
import Loading from '@components/_product-detail/ProductDetailSection/Loading'
import ProductDetailSection from '@components/_product-detail/ProductDetailSection/ProductDetailSection'
import { LeadStore, useArticleQuery } from '@generated'
import { initializeContactForm } from '@lib/initialize-contact-form'
import { CbProductPurchase as CbProductPurchaseType } from '@lib/kontent/models/CbProductPurchase'
import pinterestTracking from '@lib/pinterest-tracking'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC, useState } from 'react'

const CbProductPurchase: FC<CbProductPurchaseType> = ({ id }) => {
  const router = useRouter()
  const language = router.locale || 'en'

  const [isContactOpen, setIsContactOpen] = useState(false)
  const { t } = useTranslation('other')

  const [{ data }] = useArticleQuery({
    variables: { id: id.value },
  })

  if (!data) return <Loading />

  return (
    <>
      <ProductDetailSection
        article={data.article}
        onOpenContactModal={(type) => {
          setIsContactOpen(true)
          initializeContactForm(type, true)
        }}
        hideMainCtaMobile={true}
        galleryVariant="default"
        language={language}
      />
      <Modal
        open={isContactOpen}
        onOpenChange={(open) => setIsContactOpen(open)}
        title={t('contactUs')}
      >
        <ContactForm
          subject={`Vraag over ${data.article.brand} - ${data.article.id}`}
          leadStore={LeadStore.Gassan}
          isProductPage={true}
          onSubmitSuccess={(values) => {
            if (data.article.id) {
              pinterestTracking.lead({
                lead_type:
                  values.type === 'APPOINTMENT' ? 'product-appointment' : 'product-question',
                product_id: data.article.id,
              })
            }
            setIsContactOpen(false)
          }}
        />
      </Modal>
    </>
  )
}

export default CbProductPurchase
